const FEATURES = [
  { title: '海量综艺资源', desc: '涵盖搞笑综艺、真人秀综艺、音乐竞演等20多种类型，热门综艺每日更新，免费全集在线观看。', icon: 'ri-stack-line' },
  { title: '高清流畅播放', desc: '1080P高清画质，智能加速技术确保播放流畅不缓冲，给你影院级观影体验。', icon: 'ri-4k-line' },
  { title: '每日同步更新', desc: '与首播平台同步更新，最新综艺上线当天即可观看，不错过每一期精彩内容。', icon: 'ri-refresh-line' },
  { title: '智能推荐引擎', desc: '根据你的观看偏好精准推荐综艺内容，发现更多适合你口味的宝藏综艺节目。', icon: 'ri-rocket-line' },
  { title: '全终端适配', desc: 'PC端、平板、手机全终端适配，随时随地打开浏览器就能观看最新综艺全集。', icon: 'ri-device-line' },
];

const FAQS = [
  {
    q: '6789影视的综艺资源都是免费的吗？',
    a: '是的，6789影视平台上的所有综艺资源均为免费在线观看，包括热门综艺、搞笑综艺、真人秀综艺等各类综艺的全集内容，无需付费或会员即可畅享高清播放。',
  },
  {
    q: '综艺更新速度快吗？多久能看到最新一期？',
    a: '我们的更新速度非常快，热门综艺通常在首播当天即可上线。每日同步更新的机制确保你不会错过任何一期精彩内容，紧跟每期综艺更新节奏。',
  },
  {
    q: '播放画质如何？需要安装插件吗？',
    a: '6789影视支持1080P高清画质播放，直接通过浏览器即可观看，无需下载安装任何插件或播放器。智能加速技术确保播放过程流畅不缓冲。',
  },
  {
    q: '手机和平板可以看吗？',
    a: '完全可以！6789影视已适配PC端、平板和手机端，无论你是在家用电脑还是在通勤路上用手机，都能获得良好的综艺在线观看体验。',
  },
  {
    q: '如何找到我想看的综艺类型？',
    a: '你可以通过首页的专题合集按类型浏览，也可以使用热度榜查看当前最受欢迎的综艺节目。智能推荐引擎还会根据你的观看习惯为你推荐相关内容。',
  },
];

const CAROUSEL_ITEMS = [
  {
    title: '搞笑综艺 · 爆笑合集',
    desc: '精选全网最搞笑的热门综艺，从户外真人秀到棚内脱口秀，每期笑点密集，解压必备之选。',
    imgSrc: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20comedy%20variety%20show%20studio%20set%20with%20playful%20props%20and%20energetic%20fun%20atmosphere%20modern%20entertainment%20production%20warm%20vibrant%20lighting%20joyful%20composition&width=1200&height=600&seq=carousel-01&orientation=landscape',
    tag: '解压推荐',
    stat: '36部精选',
  },
  {
    title: '真人秀综艺 · 明星生活',
    desc: '真实记录明星日常生活与冒险挑战，从旅行到经营，从竞技到合作，感受真人秀的独特魅力。',
    imgSrc: 'https://readdy.ai/api/search-image?query=Reality%20show%20production%20style%20with%20diverse%20locations%20outdoor%20adventure%20and%20indoor%20challenge%20scenes%20warm%20cinematic%20photography%20dynamic%20composition%20natural%20lighting&width=1200&height=600&seq=carousel-02&orientation=landscape',
    tag: '热播推荐',
    stat: '28部精选',
  },
  {
    title: '治愈慢综艺 · 温暖时光',
    desc: '在快节奏生活中感受慢综艺的温暖力量，从田园牧歌到美食治愈，让心灵慢下来享受生活。',
    imgSrc: 'https://readdy.ai/api/search-image?query=Peaceful%20countryside%20garden%20setting%20with%20warm%20golden%20sunlight%20rustic%20wooden%20table%20fresh%20ingredients%20cozy%20atmosphere%20soft%20cinematic%20photography%20healing%20vibes&width=1200&height=600&seq=carousel-03&orientation=landscape',
    tag: '治愈之选',
    stat: '15部精选',
  },
  {
    title: '推理探案 · 烧脑体验',
    desc: '跟随嘉宾一步步揭开谜团，推理探案综艺带给你紧张刺激的沉浸式烧脑体验，每案都是新挑战。',
    imgSrc: 'https://readdy.ai/api/search-image?query=Mystery%20detective%20room%20with%20dramatic%20lighting%20investigation%20props%20clues%20and%20shadows%20suspenseful%20atmosphere%20modern%20escape%20room%20aesthetic%20cinematic%20composition&width=1200&height=600&seq=carousel-04&orientation=landscape',
    tag: '烧脑精选',
    stat: '12部精选',
  },
  {
    title: '经典怀旧 · 重温美好',
    desc: '回看那些年我们追过的经典综艺，从初代真人秀到国民级综艺，每一部都是满满的青春回忆。',
    imgSrc: 'https://readdy.ai/api/search-image?query=Nostalgic%20retro%20variety%20show%20aesthetic%20with%20warm%20vintage%20tones%20classic%20television%20studio%20setting%20soft%20glowing%20lights%20sentimental%20atmosphere%20timeless%20entertainment%20vibe&width=1200&height=600&seq=carousel-05&orientation=landscape',
    tag: '怀旧经典',
    stat: '24部精选',
  },
];

const TOPICS = [
  { label: '#奔跑吧兄弟', heat: '98.6万' },
  { label: '#明星大侦探', heat: '92.3万' },
  { label: '#向往的生活', heat: '87.1万' },
  { label: '#乘风破浪', heat: '81.5万' },
  { label: '#密室大逃脱', heat: '76.8万' },
  { label: '#搞笑综艺', heat: '68.2万' },
  { label: '#真人秀', heat: '63.4万' },
  { label: '#音乐竞演', heat: '58.9万' },
  { label: '#慢综艺', heat: '52.1万' },
  { label: '#中餐厅', heat: '47.6万' },
];

const CARDS = [
  {
    title: '奔跑吧兄弟 · 最新季热播中',
    desc: '全新阵容带来全新笑点，户外竞技真人秀的标杆之作，每期都是爆笑与感动的双重体验。',
    imgSrc: 'https://readdy.ai/api/search-image?query=Outdoor%20running%20man%20variety%20show%20style%20with%20bright%20sunlight%20colorful%20team%20challenges%20energetic%20atmosphere%20modern%20sports%20entertainment%20photography%20dynamic%20action%20scene&width=800&height=500&seq=cards-01&orientation=landscape',
    tag: '热播',
  },
  {
    title: '向往的生活 · 暖心收官回顾',
    desc: '一档让人慢下来的治愈慢综艺，田园生活、美食与友情，本季评分再创新高，值得重温。',
    imgSrc: 'https://readdy.ai/api/search-image?query=Cozy%20countryside%20courtyard%20with%20warm%20sunset%20light%20rustic%20kitchen%20garden%20vegetables%20and%20flowers%20peaceful%20rural%20lifestyle%20cinematic%20soft%20focus%20photography&width=800&height=500&seq=cards-02&orientation=landscape',
    tag: '完结',
  },
  {
    title: '明星大侦探 · 第十季前瞻',
    desc: '推理探案综艺天花板即将回归，原班人马再聚首，全新的案件设计与沉浸式体验值得期待。',
    imgSrc: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20investigation%20room%20with%20detective%20props%20magnifying%20glass%20and%20evidence%20board%20atmospheric%20cinematic%20lighting%20with%20shadows%20and%20warm%20highlights&width=800&height=500&seq=cards-03&orientation=landscape',
    tag: '预告',
  },
  {
    title: '乘风破浪的姐姐 · 成团之夜',
    desc: '音乐竞演综艺高光时刻，实力派姐姐们的终极舞台对决，每一场表演都堪称经典之作。',
    imgSrc: 'https://readdy.ai/api/search-image?query=Grand%20music%20stage%20performance%20with%20dramatic%20spotlights%20elegant%20performers%20in%20stunning%20costumes%20colorful%20concert%20atmosphere%20cinematic%20photography%20with%20fog%20and%20light%20beams&width=800&height=500&seq=cards-04&orientation=landscape',
    tag: '热门',
  },
  {
    title: '中餐厅 · 异国美食之旅',
    desc: '旅行体验综艺的独特魅力，明星们在海外经营中餐厅，美食、文化与温情交织的精彩故事。',
    imgSrc: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20restaurant%20interior%20with%20warm%20ambient%20lighting%20beautiful%20food%20presentation%20traditional%20and%20modern%20fusion%20dining%20atmosphere%20cinematic%20food%20photography&width=800&height=500&seq=cards-05&orientation=landscape',
    tag: '资讯',
  },
];

export function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">平台特色</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">为什么综艺迷都选择6789影视？五大核心优势告诉你</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {FEATURES.map((f) => (
            <div key={f.title} className="bg-background-50 rounded-xl p-6 text-center group hover:bg-primary-50/50 transition-colors">
              <div className="w-14 h-14 rounded-2xl bg-accent-100 text-accent-500 flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className={`${f.icon} text-2xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-800 mb-2">{f.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">关于6789影视</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">了解综艺大全背后的故事</p>
        <div className="max-w-3xl mx-auto bg-background-100 rounded-2xl p-8 md:p-10">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
            <strong>6789影视</strong>是一个专注于综艺在线观看的内容平台，致力于为广大综艺爱好者提供最新综艺、热门综艺、搞笑综艺和真人秀综艺的免费全集在线观看服务。
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
            我们深知综艺迷对内容时效性和画质的追求，因此建立了每日同步更新的机制，确保高清综艺资源第一时间上线。
            从音乐竞演到推理探案，从旅行体验到治愈慢综，平台覆盖了20多种综艺类型，满足不同观众的观看需求。
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
            6789影视坚持免费、高清、不缓冲的服务理念，持续优化播放体验和内容覆盖范围，
            希望成为每一位综艺爱好者日常追综的首选平台。如果你有好的综艺资源或建议，欢迎通过<a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-primary-500 font-semibold cursor-pointer hover:underline">联系我们</a>。
          </p>
        </div>
      </div>
    </section>
  );
}

export function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">常见问题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">关于综艺在线观看的常见疑问解答</p>
        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {FAQS.map((faq, i) => (
            <details key={i} className="group bg-background-50 rounded-xl overflow-hidden" open={i === 0}>
              <summary className="flex items-center justify-between cursor-pointer px-6 py-4 list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">{faq.q}</h3>
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-secondary-100 flex items-center justify-center text-secondary-500 text-sm group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center text-primary-500 text-sm hidden group-open:flex">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-6 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">焦点专题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">精选综艺类型专题，发现你的下一个心头好</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {CAROUSEL_ITEMS.map((item) => (
            <div key={item.title} className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer hover:-translate-y-1 transition-all duration-300">
              <div className="relative aspect-[2/1] overflow-hidden">
                <img
                  src={item.imgSrc}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500/90 text-white text-xs font-semibold rounded-full whitespace-nowrap">{item.tag}</span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2.5 py-1 bg-black/60 text-white text-xs rounded-full whitespace-nowrap">{item.stat}</span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-2 line-clamp-1">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">热门话题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">大家都在讨论的热门综艺话题，看看哪个最吸引你</p>
        <div className="max-w-4xl mx-auto flex flex-wrap justify-center gap-3">
          {TOPICS.map((t) => (
            <a
              key={t.label}
              href="#ranking"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex items-center gap-3 bg-background-50 rounded-full px-5 py-3 cursor-pointer hover:bg-primary-50 hover:scale-105 transition-all duration-200"
            >
              <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap group-hover:text-primary-600 transition-colors">{t.label}</span>
              <span className="text-xs font-medium text-primary-500 bg-primary-50 px-2 py-0.5 rounded-full whitespace-nowrap">{t.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">精选推荐</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">编辑精选的热门综艺推荐，每一部都值得一看</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {CARDS.map((card) => (
            <div key={card.title} className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer hover:-translate-y-1 transition-all duration-300">
              <div className="relative aspect-[8/5] overflow-hidden">
                <img
                  src={card.imgSrc}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500/90 text-white text-xs font-semibold rounded-full whitespace-nowrap">{card.tag}</span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-2 line-clamp-2">{card.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}